import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material'
import { content } from './products.content'

export default function BiberSpezialModal({ isOpen, onClose, ...props }) {
  const alert = content.alerts.crownCovering
  return (
    <Dialog fullWidth maxWidth={'sm'} open={isOpen} onClose={onClose} {...props}>
      <DialogTitle>{alert.title}</DialogTitle>
      <DialogContent>
        {alert.paragraphs.map((p, i) => (
          <Typography key={i} variant="body2" sx={{ mt: 1 }}>{p}</Typography>
        ))}
        <Typography variant="body2" sx={{ mt: 2, fontWeight: 'bold' }}>
          {alert.subtitle}
        </Typography>
        <ol style={{ margin: '4px 0', paddingLeft: '20px' }}>
          {alert.steps.map((step, i) => (
            <li key={i}><Typography variant="body2">{step}</Typography></li>
          ))}
        </ol>
        <Typography variant="body2" sx={{ mt: 1, fontWeight: 'bold' }}>
          {alert.footer}
        </Typography>
        <ul style={{ margin: '4px 0', paddingLeft: '20px' }}>
          {alert.footerItems.map((item, i) => (
            <li key={i}><Typography variant="body2">{item}</Typography></li>
          ))}
        </ul>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{content.ui.close}</Button>
      </DialogActions>
    </Dialog>
  )
}
